// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mat-badge-content {
  background: #5ea1d8;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
  width: 100%;
  border: 1px solid #ddd;
  margin-bottom: 20px;
}
table th {
  font-weight: 600 !important;
  font-size: 14px !important;
  color: rgba(0, 0, 0, 0.54) !important;
}

.mat-cell {
  font-size: 12px;
  font-family: "Raleway";
  display: table-cell;
  height: 48px;
  vertical-align: middle;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  border-top: 1px solid rgba(0, 0, 0, 0.12);
  border-left: 2px solid rgba(0, 0, 0, 0.12);
  border-right: 2px solid rgba(0, 0, 0, 0.12);
}

.example-list {
  max-width: 100%;
  border: solid 1px #ccc;
  height: auto !important;
  display: block;
  background: white;
  border-radius: 4px;
  overflow-y: auto;
}
.example-list .example-box {
  display: flex;
  padding: 15px 10px;
  border-bottom: 1px solid lightgrey;
  background: white !important;
}
.example-list .example-box .item-name,
.example-list .example-box .item-value {
  text-align: left;
  width: 40%;
}
.example-list .example-box .item-name,
.example-list .example-box .item-delete,
.example-list .example-box .item-reorder,
.example-list .example-box .item-value {
  text-align: left;
  padding: 5px;
  font-size: 14px;
  font-weight: 400 !important;
  overflow-wrap: break-word;
}
.example-list .example-box .item-delete,
.example-list .example-box .item-reorder {
  float: right;
  cursor: pointer;
  font-size: 20px;
  width: 10%;
}
.example-list .example-box:last-child {
  border-bottom: 0px;
}
.example-list::-webkit-scrollbar {
  width: 4px;
  height: 100px;
}
.example-list::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}
.example-list::-webkit-scrollbar-thumb {
  background-color: #5ea1d8;
  outline: 1px solid #5ea1d8;
}

.example-box {
  padding: 15px 10px;
  border-bottom: solid 1px lightgray;
  color: rgba(0, 0, 0, 0.87);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  cursor: move;
  background: white;
  font-size: 14px;
}
.example-box > div {
  width: 50%;
  display: flex !important;
}
.example-box > div:first-child {
  width: 80%;
}
.example-box > div:last-child {
  width: 17%;
}
.example-box > div > span {
  text-align: left;
  word-break: break-all;
  display: flex;
  align-items: center;
}
.example-box > div > span:first-child {
  flex: 1;
  width: 50%;
  color: rgba(0, 0, 0, 0.54) !important;
  font-weight: 400 !important;
}
.example-box > div > span:last-child {
  width: 50%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: end;
  white-space: nowrap;
  color: rgba(0, 0, 0, 0.54) !important;
  font-weight: 400 !important;
}

.cdk-drag-preview {
  box-sizing: border-box;
  border-radius: 4px;
  box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2), 0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12);
}

.main-div {
  min-height: 89vh;
  background: #efeeee !important;
}

.cdk-drag-placeholder {
  opacity: 0;
}

.cdk-drag-animating {
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}

.example-box:last-child {
  border: none;
}

.example-list.cdk-drop-list-dragging .example-box:not(.cdk-drag-placeholder) {
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}

.main-div {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
.main-div .formContent {
  border-radius: 10px 10px 10px 10px;
  background: #fff;
  padding: 20px 30px !important;
  width: 90%;
  max-width: 600px;
  width: 100%;
  position: relative;
  padding: 0px;
  box-shadow: -2px 2px 7px rgba(200, 193, 193, 0.5);
  text-align: center;
  border: 0.5px solid lightgrey;
  max-height: 600px;
  overflow: hidden;
  overflow-y: auto;
}
.main-div .formContent::-webkit-scrollbar {
  width: 4px;
  height: 100px;
}
.main-div .formContent::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}
.main-div .formContent::-webkit-scrollbar-thumb {
  background-color: #70bfe2;
  outline: 1px solid #70bfe2;
}
.main-div .top-head {
  font-size: 22px !important;
  text-align: center;
  padding: 0px;
}
.main-div .item-field .mat-form-field {
  display: block;
}
.main-div .btn-primary {
  background-color: #5ea1d8;
  border: none;
  color: #fff;
  width: 100px !important;
}
.main-div .btn-primary span {
  color: #fff !important;
}
.main-div footer {
  margin-top: 15px;
}

@media only screen and (max-width: 1024px) and (min-width: 768px) {
  .main-div {
    min-height: 92vh;
  }
  .main-content {
    width: 75%;
  }
}
@media only screen and (max-width: 767px) and (min-width: 320px) {
  .main-div {
    background: #fff !important;
  }
  .main-div .formContent {
    width: calc(100% - 30px) !important;
    padding: 5px 5px 20px !important;
  }
  .main-div .table-responsive {
    border: 0px;
  }
  .main-div .top-head {
    padding: 10px;
  }
  .main-div .example-list {
    height: 138px;
  }
  .main-div .example-box {
    padding: 8px 10px;
  }
}
button.close {
  position: absolute;
  top: 0px;
  right: 0px;
}
button.close span {
  color: rgba(0, 0, 0, 0.54) !important;
}

.itemremove span:first-child {
  width: 90% !important;
}
.example-box span:first-child {
  width: 90% !important;
  width: 10% !important;
}
.example-box span:nth-child(2) {
  width: 40% !important;
}
.example-box span:nth-child(3) {
  width: 40% !important;
}
.example-box span:last-child {
  width: 10% !important;
}

.img-div-left {
  position: fixed;
  z-index: 999;
  height: 150px;
  width: 150px;
  overflow: visible;
  margin: auto;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

.hide_file {
  position: absolute;
  z-index: 1000;
  opacity: 0;
  cursor: pointer;
  right: 0;
  top: 0;
  height: 100%;
  font-size: 24px;
  width: 100%;
}

.img-and-video-sec {
  border-radius: 5px;
  max-height: 300px;
  height: 100%;
  position: relative;
  overflow: hidden;
  min-height: 300px;
  border: 1px solid lightgray;
  display: flex;
  align-items: center;
  justify-content: center;
}
.img-and-video-sec img.img-display {
  max-width: 100%;
  max-height: 250px;
  object-fit: contain;
}
.img-and-video-sec video.video-display {
  max-width: 100%;
  max-height: 250px;
}
.img-and-video-sec p {
  color: rgba(0, 0, 0, 0.54) !important;
  text-align: left !important;
  padding: 10px;
  line-height: 20px;
}

.img-div-left.small-spinner {
  position: absolute !important;
  width: 100px !important;
  height: 100px !important;
  top: -3px !important;
}
.img-div-left.small-spinner img {
  width: 100px !important;
  height: 100px !important;
  top: unset !important;
}

.quill-wrapper .fl-left {
  margin-bottom: 10px;
  display: block;
}
.quill-wrapper quill-editor {
  width: 100%;
}

/* Ensure action links wrap if used on this page */
.commonlintbtn-parent {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
  flex-wrap: wrap;
}

/* Add space between inputs/editors and the Add Group button */
.btn-custom {
  margin-top: 12px;
}

/* Responsive fixes to prevent overlaps on narrow screens */
@media (max-width: 460px) {
  h3 {
    font-size: 16px !important;
  }
  .mat-form-field .mat-hint {
    display: block;
    width: 100%;
    margin-top: 4px;
  }
  /* Quill toolbar: allow wrapping */
  .ql-toolbar .ql-formats {
    display: inline-flex;
    flex-wrap: wrap;
    gap: 2px;
  }
  /* Wrap long text in lists */
  .example-list .example-box span,
  .example-box span {
    word-break: break-word;
    white-space: normal;
  }
}
@media screen and (max-width: 992px) {
  :host footer,
  :host .footer,
  app-faq footer,
  app-faq .footer {
    display: block !important;
    visibility: visible !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/faq/faq.component.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;AACF;;AAEA;EACE,yBAAA;EACA,iBAAA;EACA,WAAA;EACA,sBAAA;EACA,mBAAA;AACF;AAAE;EACE,2BAAA;EACA,0BAAA;EACA,qCAAA;AAEJ;;AAEA;EACE,eAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;EACA,sBAAA;EACA,4CAAA;EACA,yCAAA;EACA,0CAAA;EACA,2CAAA;AACF;;AAEA;EACE,eAAA;EACA,sBAAA;EACA,uBAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;AACF;AAAE;EACE,aAAA;EACA,kBAAA;EACA,kCAAA;EACA,4BAAA;AAEJ;AADI;;EAEE,gBAAA;EACA,UAAA;AAGN;AAAI;;;;EAIE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,2BAAA;EACA,yBAAA;AAEN;AAAI;;EAEE,YAAA;EACA,eAAA;EACA,eAAA;EACA,UAAA;AAEN;AAAI;EACE,kBAAA;AAEN;AACE;EACE,UAAA;EACA,aAAA;AACJ;AACE;EACE,oDAAA;AACJ;AACE;EACE,yBAAA;EACA,0BAAA;AACJ;;AAGA;EACE,kBAAA;EACA,kCAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;EACA,sBAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;AAAF;AACE;EACE,UAAA;EACA,wBAAA;AACJ;AAAI;EACE,UAAA;AAEN;AAAI;EACE,UAAA;AAEN;AAAI;EACE,gBAAA;EACA,qBAAA;EACA,aAAA;EACA,mBAAA;AAEN;AAAM;EACE,OAAA;EACA,UAAA;EACA,qCAAA;EACA,2BAAA;AAER;AAAM;EACE,UAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,qCAAA;EACA,2BAAA;AAER;;AAIA;EACE,sBAAA;EACA,kBAAA;EACA,qHAAA;AADF;;AAIA;EACE,gBAAA;EACA,8BAAA;AADF;;AAGA;EACE,UAAA;AAAF;;AAGA;EACE,sDAAA;AAAF;;AAGA;EACE,YAAA;AAAF;;AAGA;EACE,sDAAA;AAAF;;AAGA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AAAF;AACE;EACE,kCAAA;EACA,gBAAA;EACA,6BAAA;EACA,UAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,iDAAA;EACA,kBAAA;EACA,6BAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;AACJ;AAAI;EACE,UAAA;EACA,aAAA;AAEN;AAAI;EACE,oDAAA;AAEN;AAAI;EACE,yBAAA;EACA,0BAAA;AAEN;AAEE;EACE,0BAAA;EACA,kBAAA;EACA,YAAA;AAAJ;AAGI;EACE,cAAA;AADN;AAIE;EACE,yBAAA;EACA,YAAA;EACA,WAAA;EACA,uBAAA;AAFJ;AAGI;EACE,sBAAA;AADN;AAIE;EACE,gBAAA;AAFJ;;AAMA;EACE;IACE,gBAAA;EAHF;EAKA;IACE,UAAA;EAHF;AACF;AAMA;EACE;IACE,2BAAA;EAJF;EAKE;IACE,mCAAA;IACA,gCAAA;EAHJ;EAKE;IACE,WAAA;EAHJ;EAKE;IACE,aAAA;EAHJ;EAKE;IACE,aAAA;EAHJ;EAKE;IACE,iBAAA;EAHJ;AACF;AAOA;EACE,kBAAA;EACA,QAAA;EACA,UAAA;AALF;AAME;EACE,qCAAA;AAJJ;;AAUI;EACE,qBAAA;AAPN;AAgBI;EACE,qBAAA;EACA,qBAAA;AAdN;AAgBI;EACE,qBAAA;AAdN;AAgBI;EACE,qBAAA;AAdN;AAgBI;EACE,qBAAA;AAdN;;AAmBA;EACE,eAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;EACA,iBAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;AAhBF;;AAmBA;EACE,kBAAA;EACA,aAAA;EACA,UAAA;EACA,eAAA;EACA,QAAA;EACA,MAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;AAhBF;;AAmBA;EACE,kBAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAhBF;AAiBE;EACE,eAAA;EACA,iBAAA;EACA,mBAAA;AAfJ;AAiBE;EACE,eAAA;EACA,iBAAA;AAfJ;AAiBE;EACE,qCAAA;EACA,2BAAA;EACA,aAAA;EACA,iBAAA;AAfJ;;AAkBA;EAGE,6BAAA;EACA,uBAAA;EACA,wBAAA;EAEA,oBAAA;AAlBF;AAoBA;EACE,uBAAA;EACA,wBAAA;EACA,qBAAA;AAlBF;;AAuBI;EACE,mBAAA;EACA,cAAA;AApBN;AAsBI;EACE,WAAA;AApBN;;AAwBA,kDAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,QAAA;EACA,eAAA;AArBF;;AAwBA,8DAAA;AACA;EACE,gBAAA;AArBF;;AAwBA,2DAAA;AACA;EACE;IAAK,0BAAA;EApBL;EAqBA;IAA4B,cAAA;IAAgB,WAAA;IAAa,eAAA;EAhBzD;EAkBA,kCAAA;EACA;IACE,oBAAA;IACA,eAAA;IACA,QAAA;EAhBF;EAmBA,4BAAA;EACA;;IAEE,sBAAA;IACA,mBAAA;EAjBF;AACF;AAqBA;EACE;;;;IAIE,yBAAA;IACA,8BAAA;EAnBF;AACF","sourcesContent":[".mat-badge-content {\n  background: #5ea1d8;\n}\n\ntable {\n  border-collapse: collapse;\n  border-spacing: 0;\n  width: 100%;\n  border: 1px solid #ddd;\n  margin-bottom: 20px;\n  th {\n    font-weight: 600 !important;\n    font-size: 14px !important;\n    color: rgba(0, 0, 0, 0.54) !important;\n  }\n}\n\n.mat-cell {\n  font-size: 12px;\n  font-family: \"Raleway\";\n  display: table-cell;\n  height: 48px;\n  vertical-align: middle;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.12);\n  border-top: 1px solid rgba(0, 0, 0, 0.12);\n  border-left: 2px solid rgba(0, 0, 0, 0.12);\n  border-right: 2px solid rgba(0, 0, 0, 0.12);\n}\n\n.example-list {\n  max-width: 100%;\n  border: solid 1px #ccc;\n  height: auto !important;\n  display: block;\n  background: white;\n  border-radius: 4px;\n  overflow-y: auto;\n  .example-box {\n    display: flex;\n    padding: 15px 10px;\n    border-bottom: 1px solid lightgrey;\n    background: white !important;\n    .item-name,\n    .item-value {\n      text-align: left;\n      width: 40%;\n    }\n\n    .item-name,\n    .item-delete,\n    .item-reorder,\n    .item-value {\n      text-align: left;\n      padding: 5px;\n      font-size: 14px;\n      font-weight: 400 !important;\n      overflow-wrap: break-word;\n    }\n    .item-delete,\n    .item-reorder {\n      float: right;\n      cursor: pointer;\n      font-size: 20px;\n      width: 10%;\n    }\n    &:last-child {\n      border-bottom: 0px;\n    }\n  }\n  &::-webkit-scrollbar {\n    width: 4px;\n    height: 100px;\n  }\n  &::-webkit-scrollbar-track {\n    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n  }\n  &::-webkit-scrollbar-thumb {\n    background-color: #5ea1d8;\n    outline: 1px solid #5ea1d8;\n  }\n}\n\n.example-box {\n  padding: 15px 10px;\n  border-bottom: solid 1px lightgray;\n  color: rgba(0, 0, 0, 0.87);\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  box-sizing: border-box;\n  cursor: move;\n  background: white;\n  font-size: 14px;\n  & > div {\n    width: 50%;\n    display: flex !important;\n    &:first-child {\n      width: 80%;\n    }\n    &:last-child {\n      width: 17%;\n    }\n    & > span {\n      text-align: left;\n      word-break: break-all;\n      display: flex;\n      align-items: center;\n\n      &:first-child {\n        flex: 1;\n        width: 50%;\n        color: rgba(0, 0, 0, 0.54) !important;\n        font-weight: 400 !important;\n      }\n      &:last-child {\n        width: 50%;\n        text-align: center;\n        display: flex;\n        align-items: center;\n        justify-content: end;\n        white-space: nowrap;\n        color: rgba(0, 0, 0, 0.54) !important;\n        font-weight: 400 !important;\n      }\n    }\n  }\n}\n\n.cdk-drag-preview {\n  box-sizing: border-box;\n  border-radius: 4px;\n  box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2),\n    0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12);\n}\n.main-div {\n  min-height: 89vh;\n  background: #efeeee !important;\n}\n.cdk-drag-placeholder {\n  opacity: 0;\n}\n\n.cdk-drag-animating {\n  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);\n}\n\n.example-box:last-child {\n  border: none;\n}\n\n.example-list.cdk-drop-list-dragging .example-box:not(.cdk-drag-placeholder) {\n  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);\n}\n\n.main-div {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  .formContent {\n    border-radius: 10px 10px 10px 10px;\n    background: #fff;\n    padding: 20px 30px !important;\n    width: 90%;\n    max-width: 600px;\n    width: 100%;\n    position: relative;\n    padding: 0px;\n    box-shadow: -2px 2px 7px rgb(200 193 193 / 50%);\n    text-align: center;\n    border: 0.5px solid lightgrey;\n    max-height: 600px;\n    overflow: hidden;\n    overflow-y: auto;\n    &::-webkit-scrollbar {\n      width: 4px;\n      height: 100px;\n    }\n    &::-webkit-scrollbar-track {\n      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n    }\n    &::-webkit-scrollbar-thumb {\n      background-color: #70bfe2;\n      outline: 1px solid #70bfe2;\n    }\n  }\n\n  .top-head {\n    font-size: 22px !important;\n    text-align: center;\n    padding: 0px;\n  }\n  .item-field {\n    .mat-form-field {\n      display: block;\n    }\n  }\n  .btn-primary {\n    background-color: #5ea1d8;\n    border: none;\n    color: #fff;\n    width: 100px !important;\n    span {\n      color: #fff !important;\n    }\n  }\n  footer {\n    margin-top: 15px;\n  }\n}\n\n@media only screen and (max-width: 1024px) and (min-width: 768px) {\n  .main-div {\n    min-height: 92vh;\n  }\n  .main-content {\n    width: 75%;\n  }\n}\n\n@media only screen and (max-width: 767px) and (min-width: 320px) {\n  .main-div {\n    background: #fff !important;\n    .formContent {\n      width: calc(100% - 30px) !important;\n      padding: 5px 5px 20px !important;\n    }\n    .table-responsive {\n      border: 0px;\n    }\n    .top-head {\n      padding: 10px;\n    }\n    .example-list {\n      height: 138px;\n    }\n    .example-box {\n      padding: 8px 10px;\n    }\n  }\n}\n\nbutton.close {\n  position: absolute;\n  top: 0px;\n  right: 0px;\n  span {\n    color: rgba(0, 0, 0, 0.54) !important;\n  }\n}\n\n.itemremove {\n  span {\n    &:first-child {\n      width: 90% !important;\n    }\n    &:nth-child(2) {\n      // display:none;\n    }\n  }\n}\n.example-box {\n  span {\n    &:first-child {\n      width: 90% !important;\n      width: 10% !important;\n    }\n    &:nth-child(2) {\n      width: 40% !important;\n    }\n    &:nth-child(3) {\n      width: 40% !important;\n    }\n    &:last-child {\n      width: 10% !important;\n    }\n  }\n}\n\n.img-div-left {\n  position: fixed;\n  z-index: 999;\n  height: 150px;\n  width: 150px;\n  overflow: visible;\n  margin: auto;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n}\n\n.hide_file {\n  position: absolute;\n  z-index: 1000;\n  opacity: 0;\n  cursor: pointer;\n  right: 0;\n  top: 0;\n  height: 100%;\n  font-size: 24px;\n  width: 100%;\n}\n\n.img-and-video-sec {\n  border-radius: 5px;\n  max-height: 300px;\n  height: 100%;\n  position: relative;\n  overflow: hidden;\n  min-height: 300px;\n  border: 1px solid lightgray;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  img.img-display {\n    max-width: 100%;\n    max-height: 250px;\n    object-fit: contain;\n  }\n  video.video-display {\n    max-width: 100%;\n    max-height: 250px;\n  }\n  p {\n    color: rgba(0, 0, 0, 0.54) !important;\n    text-align: left !important;\n    padding: 10px;\n    line-height: 20px;\n  }\n}\n.img-div-left.small-spinner{\n \n   \n  position: absolute !important;\n  width: 100px !important;\n  height: 100px !important;\n \n  top: -3px !important;\n\nimg{\n  width:100px !important;\n  height:100px !important;\n  top:unset !important;\n}\n}\n\n.quill-wrapper{\n    .fl-left{\n      margin-bottom: 10px;\n      display: block;\n    }\n    quill-editor{\n      width: 100%;\n    }\n  }\n\n/* Ensure action links wrap if used on this page */\n.commonlintbtn-parent {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n/* Add space between inputs/editors and the Add Group button */\n.btn-custom {\n  margin-top: 12px;\n}\n\n/* Responsive fixes to prevent overlaps on narrow screens */\n@media (max-width: 460px) {\n  h3 { font-size: 16px !important; }\n  .mat-form-field .mat-hint { display: block; width: 100%; margin-top: 4px; }\n\n  /* Quill toolbar: allow wrapping */\n  .ql-toolbar .ql-formats {\n    display: inline-flex;\n    flex-wrap: wrap;\n    gap: 2px;\n  }\n\n  /* Wrap long text in lists */\n  .example-list .example-box span,\n  .example-box span {\n    word-break: break-word;\n    white-space: normal;\n  }\n}\n\n// Override global mobile footer hiding for FAQ page\n@media screen and (max-width: 992px) {\n  :host footer,\n  :host .footer,\n  app-faq footer,\n  app-faq .footer {\n    display: block !important;\n    visibility: visible !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
